import React, { useState } from 'react'
import Button, { TYPES } from '../../../Button/index'
import IconV2, { ICON_TYPES, ICON_STYLES } from '../../../Icon.v2/index'

export default function AccountSecurity (props) {
  const { staticText, onSubmit, auth } = props
  const processing = auth.get('processing')
  const processingRenew = auth.get('processingRenew')
  const success = auth.get('success')
  const userAccountAuthenticationGroupId = auth.get('userAccountAuthenticationGroupId')
  const [
    prevUserAccountAuthenticationGroupId,
    setPrevUserAccountAuthenticationGroupId,
  ] = useState(userAccountAuthenticationGroupId)
  const isProcessing = processing && processingRenew
  const isSuccessful = !processing
    && !processingRenew
    && success
    && userAccountAuthenticationGroupId !== prevUserAccountAuthenticationGroupId
  const hasError = !processing
    && !processingRenew
    && !success
    && userAccountAuthenticationGroupId === prevUserAccountAuthenticationGroupId

  const handleClick = () => {
    // The userAccountAuthenticationGroupId is incremented upon succesful log out
    // We store this state to compare against when the auth renew happens to determine
    // if the call was succesful or not
    setPrevUserAccountAuthenticationGroupId(userAccountAuthenticationGroupId)
    onSubmit()
  }

  if (isSuccessful) {
    return (
      <div className="account-security__success">
        <IconV2
          className="account-security__success-icon"
          type={ICON_TYPES.CHECK}
          style={ICON_STYLES.TEAL_CIRCLE}
        />
        <p>{staticText.getIn(['data', 'accountSecurityConfirmation'])}</p>
      </div>
    )
  }

  return (
    <React.Fragment>
      <p>{staticText.getIn(['data', 'accountSecurityDescription'])}</p>
      { hasError ? <p className="account-security__error">{staticText.getIn(['data', 'accountSecurityError'])}</p> : null}
      <Button
        disabled={isProcessing}
        type={TYPES.PRIMARY}
        className="account-security__button"
        onClick={handleClick}
      >
        {isProcessing
          ? staticText.getIn(['data', 'accountSecurityProcessing'])
          : staticText.getIn(['data', 'accountSecurityButton'])
        }
      </Button>
    </React.Fragment>
  )
}
